import { Flex, FlexProps, Stack, Text } from '@chakra-ui/react';

import { columnWidths } from './columns-width';

export function VoucherSectionHeading() {
  const headerFlexProps: FlexProps = {
    w: 'full',
    bgColor: '#E6E6F6',
    px: 4,
    py: 5,
    fontWeight: 'bold',
    alignItems: 'center',
  };

  return (
    <Flex {...headerFlexProps}>
      <Flex w={columnWidths.dragHandle} justify="center" />
      <Flex w={columnWidths.thumbnail} justify="center">
        <Text fontSize="sm">Thumbnail</Text>
      </Flex>
      <Flex w={columnWidths.code} justify="center">
        <Text fontSize="sm">Kode Voucher</Text>
      </Flex>
      <Flex w={columnWidths.mechanism} justify="center">
        <Text fontSize="sm">Mekanisme</Text>
      </Flex>
      <Flex w={columnWidths.branch} justify="center">
        <Text fontSize="sm">Cabang</Text>
      </Flex>
      <Flex w={columnWidths.cg1} justify="center">
        <Text fontSize="sm">CG1</Text>
      </Flex>
      <Flex w={columnWidths.cg2} justify="center">
        <Text fontSize="sm">CG2</Text>
      </Flex>
      <Flex w={columnWidths.usage} justify="center">
        <Text fontSize="sm">Pemakaian</Text>
      </Flex>
      <Flex w={columnWidths.activeStatus} justify="center">
        <Text fontSize="sm">Voucher Aktif</Text>
      </Flex>
      <Flex w={columnWidths.displayStatus} justify="center">
        <Text fontSize="sm">Tampil di SOL</Text>
      </Flex>
      <Flex w={columnWidths.actions} justify="center">
        <Text fontSize="sm">Aksi</Text>
      </Flex>
    </Flex>
  );
}
